// extracted by mini-css-extract-plugin
module.exports = {"credit":"credit--3hDzO","is-embed":"is-embed--2w1uR","isEmbed":"is-embed--2w1uR","icon":"icon--37pzE","name":"name--3ySxx"};